export default __webpack_public_path__ + "media/placeholder/email-wallpaper-7aa93abf.jpg";